/* eslint no-underscore-dangle:  0 */
/* eslint-disable no-debugger, no-console */
/* eslint-disable */
import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { getAllClients } from 'Redux/actions/mobileFinnance';
import { useDispatch } from 'react-redux';
import { getAllMobileFinnance } from 'Redux/actions/mobileFinnance';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    //   width: "500px",
      border: "none",
    },
  },
};


function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
    color: "black",
  };
}

export default function MultipleSelectPlaceholder({clients,setClient}) {
  // console.log(props.clients);
  // let clients = props.clients;
  // console.log (clients);
  
  const theme = useTheme();
  const [personName, setPersonName] = React.useState([]);
  const dispatch = useDispatch();
  // const clientss = useSelector((state) => state.mobileFinnance);
  // console.log(clientss);
  let client = localStorage.getItem('nagadClient')?localStorage.getItem('nagadClient'):"all";
  // console.log(client)
  React.useEffect(() => {
    dispatch(getAllClients("nagad"));
    dispatch(getAllMobileFinnance(1, 10, client, "nagad"))
  }, [dispatch]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(
      // On autofill we get a stringified value.
       value.name?(value.name + " " + value.number):"all",
    );
    setClient(value.number?value.number:"all");
    localStorage.setItem('nagadClient',value.number?value.number:"all");
    localStorage.setItem('nagadClientName',value.name?(value.name + " " + value.number):"All Client");
  };


  return (
    <div>
      <FormControl sx={{  width:"100%",bgcolor:"white",borderRadius:"10px",color:"black" }}>
        <Select
        sx={{color:"black",bgcolor:"white",borderRadius:"5px",height:"50px"}}
        
        //   multiple
          displayEmpty
          value={personName}
          onChange={handleChange}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            if (selected.length === 0) {
              return <em>{localStorage.getItem('nagadClientName')?localStorage.getItem('nagadClientName'):"Select Client"}</em>;
            }

            return selected;
          }}
          MenuProps={MenuProps}
          inputProps={{ 'aria-label': 'Without label' }}
        > 
          <MenuItem value="all">
            <em>All Client</em>
          </MenuItem>
          {clients?.map((client) => (
            <MenuItem
              key={client._id}
              value={client}
              style={getStyles(client.name, personName, theme)}
            >
              {client.name+"    "+"("+client.number} <span style={{}}>{client.isInvestor?"-Investor"+")":""+")"}</span>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}